import { render, staticRenderFns } from "./SettingsGame.vue?vue&type=template&id=24ab84e0&scoped=true&"
import script from "./SettingsGame.vue?vue&type=script&lang=js&"
export * from "./SettingsGame.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGame.vue?vue&type=style&index=0&id=24ab84e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab84e0",
  null
  
)

export default component.exports